import { render, staticRenderFns } from "./galleryStandard.vue?vue&type=template&id=784c5f86&scoped=true&"
import script from "./galleryStandard.vue?vue&type=script&lang=js&"
export * from "./galleryStandard.vue?vue&type=script&lang=js&"
import style0 from "./galleryStandard.vue?vue&type=style&index=0&id=784c5f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784c5f86",
  null
  
)

export default component.exports